import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: '产品中心' },
  },
  {
    path: '/products/:category/:slug',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情' },
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('@/views/Solutions.vue'),
    meta: { title: '解决方案' },
  },
  {
    path: '/solutions/:slug',
    name: 'SolutionDetail',
    component: () => import('@/views/SolutionDetail.vue'),
    meta: { title: '方案详情' },
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('@/views/Partners.vue'),
    meta: { title: '合作伙伴' },
  },
  {
    path: '/cases',
    redirect: '/partners',
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: { title: '联系我们' },
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.afterEach((to) => {
  const base = '苏成（江苏）能源科技'
  document.title = to.meta.title ? `${to.meta.title} - ${base}` : base
})

export default router
